import * as React from 'react';
import { Box } from '@mui/material';

const SideBarTitle = (props) => {
    return <Box {...props} >{props.text} </Box>
}

export default SideBarTitle;